import Icon from '@/components/public/ui/Icon';

interface MonthSelectorProps {
  month: number;
  year: number;
  onChange: (month: number, year: number) => void;
  className?: string;
}

const monthNames = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
];

// Light month stepper — same surface/line language as the DatePicker nav.
export default function MonthSelector({
  month,
  year,
  onChange,
  className = '',
}: MonthSelectorProps) {
  const handlePrev = () => (month === 0 ? onChange(11, year - 1) : onChange(month - 1, year));
  const handleNext = () => (month === 11 ? onChange(0, year + 1) : onChange(month + 1, year));

  return (
    <div
      className={`border-line bg-surface inline-flex h-11 items-center overflow-hidden rounded-md border ${className}`}
    >
      <button
        type="button"
        onClick={handlePrev}
        className="text-on-surface-light hover:bg-primary/5 hover:text-primary flex h-full w-11 items-center justify-center transition-colors duration-200"
        aria-label="Mês anterior"
      >
        <Icon name="chevron_left" size="sm" />
      </button>

      <div className="bg-line h-6 w-px flex-shrink-0" />

      <span className="font-headline text-on-surface min-w-[148px] px-2 text-center text-sm font-semibold select-none">
        {monthNames[month]} {year}
      </span>

      <div className="bg-line h-6 w-px flex-shrink-0" />

      <button
        type="button"
        onClick={handleNext}
        className="text-on-surface-light hover:bg-primary/5 hover:text-primary flex h-full w-11 items-center justify-center transition-colors duration-200"
        aria-label="Próximo mês"
      >
        <Icon name="chevron_right" size="sm" />
      </button>
    </div>
  );
}
